<template lang="jade">
  include ./mixin.jade
  +simpleGetButton('dxGetMatrixStatus')
  //- =============== dxSetMapping =============================
  .row
    .col-xs-12
      fieldset
        legend dxSetMapping
        div(v-for="setting in mapping" track-by="$index")
          span set output
          input.thin(v-model="setting.port")
          span value
          input.thin(v-model="setting.value")

        button(@click="dxSetMapping") dxSetMapping

  +simpleGetButton('dxGetPortInfo')
  //- ================ dxSetPortInfo =============================
  .row
    .col-xs-12
      fieldset
        legend dxSetPortInfo
        div(v-for="inp in info.inputs" track-by="$index")
          div
            span input port :
            input(v-model='inp.port')
          div
            span input port {{ inp.port }}.name :
            input(v-model='inp.name')
          div
            span input port {{ inp.port }}.photo :
            input(v-model='inp.photo')
        div(v-for="inp in info.outputs" track-by="$index")
          div
            span output port :
            input(v-model='inp.port')
          div
            span output port {{ inp.port }}.name :
            input(v-model='inp.name')
          div
            span output port {{ inp.port }}.photo :
            input(v-model='inp.photo')

        button(@click="dxSetPortInfo") dxSetPortInfo
  +simpleGetButton('dxGetHDCPStatus')
  +simpleGetButton('dxGetHDCP')
  .row
    .col-xs-12
      fieldset
        legend dxSetHDCP
        //- div(v-for="inp in hdcp.inputs" track-by="$index")
        //-   div
        //-     span input port :
        //-     input(v-model='inp.port')
        //-   div
        //-     span input port {{ inp.port }}.enabled :
        //-     input(type="checkbox" v-model='inp.enabled')
        //-   div
        //-     span input port {{ inp.port }}.engine :
        //-     span(v-for='op in engineOpts')
        //-       input(type="radio" value="{{op}}" v-bind:id=" 'r_' + op + $index" v-model='inp.engine')
        //-       label(v-bind:for=" 'i_' + op + $index") {{ op }}
        div(v-for="oup in hdcp.outputs" track-by="$index")
          div
            span output port :
            input(v-model='oup.port')
          div
            span output port {{ oup.port }}.enabled :
            input(type="checkbox" v-model='oup.enabled')
          div
            span output port {{ oup.port }}.engine :
            span(v-for='op in engineOpts')
              input(type="radio" value="{{op}}" v-bind:id=" 'r_' + op + $index" v-model='oup.engine')
              label(v-bind:for=" 'o_' + op + $index") {{ op }}

        button(@click="dxSetHDCP") dxSetHDCP
  +simpleGetButton('dxGetMaps')
  .row
    .col-xs-12
      fieldset
        legend dxSetMaps
        div
          span config map id :
          input(v-model='maps.no')
        div
          span amout of port wanna send:
          input(type="number" v-model='maps.count' number)
        div
          span name :
          input(v-model='maps.name')
        div(v-for="count in maps.count" track-by="$index")
          span output : {{ count + 1 }}
          input(v-model='maps.mapping[count+1]')

        button(@click="dxSetMaps") dxSetMaps
  +simpleGetButton('dxGetEDID')
  +simpleGetButton('dxGetEDIDOptions')
  .row
    .col-xs-12
      fieldset
        legend dxSetEDID
        div
          span port:
          input(v-model='edid.no')
        div
          span type
          span(v-for='op in edidOpts')
            input(type="radio" value="{{op}}" id="edidCbx" v-model='edid.type')
            label(v-bind:for="edidCbx") {{ op }}
        div
          span value :
          textarea(v-model='edid.value')

        button(@click="dxSetEDID") dxSetEDID
  .row
    .col-xs-12
      fieldset
        legend dxResetLink
        div
          span inputs ports:
          each value in [1, 2, 3, 4, 5, 6, 7, 8]
            input(type="checkbox" value=value v-model="toResetLinks.inputs")
            label=value
        div
          span outputs ports:
          each value in [1, 2, 3, 4, 5, 6, 7, 8]
            input(type="checkbox" value=value v-model="toResetLinks.outputs")
            label=value
        button(@click="dxResetLink") dxResetLink
  +simpleGetButton('dxGetSwitcherLayout')
  .row
    .col-xs-12
      fieldset
        legend dxSetSwitcherLayout
        div
          span Layout:
            input(type="text" v-model="switcherLayout")
        button(@click="dxSetSwitcherLayout") dxSetSwitcherLayout
  .row
    .col-xs-12
      fieldset
        legend dxSetMappingAndLayout
        div
          span Layout:
            input(type="text" v-model="switcherLayout")
        div
          span Mapping:
            input(type="text" v-model="switcherMapping")
        button(@click="dxSetMappingAndLayout") dxSetMappingAndLayout

</template>

<script>
  export default {
    data: () => ({
      mapping: [{
        port: '2',
        value: '3'
      }, {
        port: '3',
        value: '3'
      }],
      info: {
        inputs: [{
          port: '2',
          name: 'DVD',
          photo: '1'
        }, {
          port: '3',
          name: 'PS4',
          photo: '3'
        }],
        outputs: [{
          port: '4',
          name: 'Room',
          photo: '2'
        }, {
          port: '5',
          name: 'Lobby',
          photo: '2'
        }]
      },
      engineOpts: ['0', '1.4', '2.2'],
      hdcp: {
        inputs: [{
          port: '2',
          enabled: true,
          engine: '0'
        }, {
          port: '3',
          enabled: true,
          engine: '0'
        }],
        outputs: [{
          port: '3',
          enabled: true,
          engine: '0'
        }, {
          port: '4',
          enabled: true,
          engine: '0'
        }]
      },
      maps: {
        no: '2',
        name: 'profile1',
        count: 4,
        mapping: {}
      },
      edidOpts: ['default', 'HDMI', 'HDBT', 'custom', 'auto'],
      edid: {
        no: '2',
        type: 'default',
        value: '1'
      },
      toResetLinks: {
        inputs: [],
        outputs: []
      },
      switcherLayout: '0',
      switcherMapping: '1'
    }),
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSetMappingAndLayout () {
        this.sendAPI('dxSetMappingAndLayout', {
          layout: this.switcherLayout,
          mapping: {
            '1': this.switcherMapping
          }
        })
      },
      dxSetSwitcherLayout () {
        this.sendAPI('dxSetSwitcherLayout', {
          layout: this.switcherLayout
        })
      },
      dxSetMapping () {
        let mapping = {}
        for (let setting of this.mapping) {
          mapping[setting.port] = setting.value
        }
        this.sendAPI('dxSetMapping', { mapping })
      },
      dxSetPortInfo () {
        let params = {
          inputs: {},
          outputs: {}
        }
        for (let setting of this.info.inputs) {
          params.inputs[setting.port] = {
            photo: setting.photo,
            name: setting.name
          }
        }
        for (let setting of this.info.outputs) {
          params.outputs[setting.port] = {
            photo: setting.photo,
            name: setting.name
          }
        }
        this.sendAPI('dxSetPortInfo', params)
      },
      dxSetHDCP () {
        let params = {
          // inputs: {},
          outputs: {}
        }
        // for (let setting of this.hdcp.inputs) {
        //   params.inputs[setting.port] = {
        //     enabled: setting.enabled,
        //     engine: setting.engine
        //   }
        // }
        for (let setting of this.hdcp.outputs) {
          params.outputs[setting.port] = {
            enabled: setting.enabled,
            engine: setting.engine
          }
        }
        this.sendAPI('dxSetHDCP', params)
      },
      dxSetMaps () {
        let mapping = {}
        for (let i = 1; i <= this.maps.count; i++) {
          mapping[i] = this.maps.mapping[i]
        }
        let maps = {
          [this.maps.no]: {
            name: this.maps.name,
            mapping
          }
        }
        this.sendAPI('dxSetMaps', { maps })
      },
      dxSetEDID () {
        this.sendAPI('dxSetEDID', {
          inputs: {
            [this.edid.no]: {
              type: this.edid.type,
              value: this.edid.value
            }
          }
        })
      },
      dxResetLink () {
        this.sendAPI('dxResetLink', this.toResetLinks)
      }
    }
  }
</script>

<style scoped>
  .thin {
    width: 16%;
  }
</style>



// WEBPACK FOOTER //
// matrix.vue?cef5c108